/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const XSDValidationR = t.interface({
  detail: t.string,

  xsdCompliant: t.boolean,

  xsdSchema: t.string
});

// optional attributes
const XSDValidationO = t.partial({});

export const XSDValidation = t.intersection(
  [XSDValidationR, XSDValidationO],
  "XSDValidation"
);

export type XSDValidation = t.TypeOf<typeof XSDValidation>;
